<nav mat-tab-nav-bar class="easy-tab" [tabPanel]="tabPanel">
  <a
    mat-tab-link
    *ngFor="let link of navLinks"
    [routerLink]="link.link"
    routerLinkActive
    #rla="routerLinkActive"
    [active]="rla.isActive"
  >
    {{ link.label | async }}
  </a>
</nav>
